const enviroments = {
    urlBase: '',
    // urlBase: '/digicel-demo',
    site_key: '6LdUiZkqAAAAAHSxmZJNCk5FHaUgUe5yVRLoM6a9'
};

export default enviroments;